// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__V06q5","spinner_inner":"Spinner_spinner_inner__OP0EB","active":"Spinner_active__Ciapf","spin":"Spinner_spin__Dfcyj","fixed":"Spinner_fixed__B_qcv"};